var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7731 7.10171C19.9846 2.7877 15.7559 0 11 0C6.24413 0 2.01538 2.7877 0.226884 7.10171C-0.0756282 7.83141 -0.0756282 8.66836 0.226884 9.39898C2.01538 13.713 6.24413 16.5007 11 16.5007C15.7559 16.5007 19.9846 13.713 21.7731 9.39898C22.0756 8.66928 22.0756 7.83141 21.7731 7.10171ZM11 11.9172C8.97775 11.9172 7.33318 10.2726 7.33318 8.25034C7.33318 6.22809 8.97775 4.58352 11 4.58352C13.0223 4.58352 14.6668 6.22809 14.6668 8.25034C14.6668 10.2726 13.0223 11.9172 11 11.9172Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.4e04b6626d66da293129c3a726896fd9.svg";
export { ForwardRef as ReactComponent };